import { EditOutlined } from "@mui/icons-material";
import { Button, Divider } from "@mui/material";
import { Link, useParams } from "react-router-dom";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAppMeta, useAuth } from "hooks";
import { useGetAnnouncementDetailQuery } from "store/services/announcementApi";
import { AnnouncementDetailContext } from "contexts/AnnouncementDetailContext";
import AnnouncementBasicDetail from "./announcementComponents/AnnouncementBasicDetail";
import { AnnouncementDetailTabs } from "./announcementComponents/AnnouncementDetailTab";

const AnnouncementDetailScreen = () => {
  const { id } = useParams();
  const { isAdmin } = useAuth()

  const breadcrumbs = [
    {
      title: "Announcements",
      path: isAdmin
        ? "/app/crm/announcement/list"
        : "/app/vendor/announcement/list",
    },
    { title: "Announcement Detail" },
  ];

  //   RTK Query
  const {
    data: announcementDetail,
    isLoading: loadingAnnouncementDetail,
    error,
  } = useGetAnnouncementDetailQuery(id);

  const PageActions = () => (
    <Link to={`/app/crm/announcement/${id}/edit`}>
      {isAdmin && (<Button variant="contained" startIcon={<EditOutlined />}>
        Edit
      </Button>)}
    </Link>
  );
  useAppMeta("Announcement Detail");

  return (
    <AnnouncementDetailContext.Provider
      value={{ announcementDetail, loadingAnnouncementDetail }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingAnnouncementDetail}
        error={error}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />
        <AnnouncementBasicDetail />

        <Divider />

        {announcementDetail?.canReply &&
          <AnnouncementDetailTabs />}
      </BreadcrumbLayout>
    </AnnouncementDetailContext.Provider>
  );
};

export default AnnouncementDetailScreen;
